import { Autocomplete, Grid } from "@mui/material";
import { EnumAutocomplete } from "components/alove/EnumAutocomplete";
import { Action, NextScreenEvent } from "models/content/Comm";
import { Content, ContentType } from "models/content/Content";
import { GeneralCode } from "models/content/GeneralCode";
import { appPages, ScreenModel } from "models/content/Screen";
import { useEffect, useState } from "react";
import { getContents } from "utils/contentUtils";
import { camelCaseToCapitalizedWords, getUrlFromAction, uniqueBy } from "utils/globalsUtils";
import { getScreens } from "utils/screenUtils";

const MDInput = require("components/MDInput/index.js").default;

export const ActionSetting = ({ action, setAction, setUrl, screens }: {
  action: Action, 
  setAction?: (action: Action) => void, 
  setUrl?: (url: string) => void,
  screens?: ScreenModel[]}) => {
  const [contents, setContents] = useState<Content[]>([]);
  const [categories, setCategories] = useState<GeneralCode[]>([]);
  const [currentCategory, setCurrentCategory] = useState<GeneralCode | null>(null);
  useEffect(() => {
    getContents(undefined, true).then((contents) => {
      setContents(contents);
      setCategories(uniqueBy(contents.map((c) => c.category).filter((c) => c !== null), "id"));
      setCurrentCategory(contents.find((c) => c.id == action.actionUrl)?.category || null);
    }
    );
  }, []);
  const [_screens, setScreens] = useState<ScreenModel[]>([]);
  useEffect(() => {
    if (screens !== undefined ) {
      setScreens(screens);
    } else {
      getScreens().then((screens) => {
        setScreens(screens);
      });
    }
  }
  , []);

  const _setAction = (action) => {
    setAction?.(action);
    setUrl?.(getUrlFromAction(action));
  }

  return (
    <Grid container spacing={1}>
      <Grid size={6}>
        <Autocomplete
          value={action?.nextEventType || NextScreenEvent.none}
          fullWidth
          getOptionLabel={(option: string) => camelCaseToCapitalizedWords(option?.toString())}
          onChange={(e, o) => _setAction({ ...action, nextEventType: o })}
          options={Object.values(NextScreenEvent).filter((key) => isNaN(Number(key)))}
          renderInput={(params) => <MDInput {...params} label="Event Type" />}
        />
      </Grid>
      {action?.nextEventType === NextScreenEvent.genericScreen ? (
        <Grid size={6}>
          <Autocomplete
            value={_screens.find((s) => s.id == action.actionUrl) || ({} as ScreenModel)}
            fullWidth
            getOptionLabel={(option: ScreenModel) => option.name}
            onChange={(e, o) => _setAction({ ...action, actionUrl: o?.id })}
            options={_screens}
            renderInput={(params) => <MDInput {...params} label="Next action" />}
          />
        </Grid>
      ) : action?.nextEventType === NextScreenEvent.appScreen ? (
        <Grid size={6}>
          <Autocomplete
            value={action.actionUrl?.toString() || "" }
            fullWidth
            freeSolo
            getOptionLabel={(option: string) => camelCaseToCapitalizedWords(option)}
            onChange={(e, o) => _setAction({ ...action, actionUrl: o })}
            options={appPages}
            renderInput={(params) => <MDInput {...params} label="Action URL" />}
          />
        </Grid>
        ) : action?.nextEventType === NextScreenEvent.contentScreen ? (
          <Grid container spacing={1}>
            <Grid size={6}>
            <Autocomplete
              value={currentCategory}
              fullWidth
              getOptionLabel={(option: GeneralCode) => option?.name}
              onChange={(e, o) => setCurrentCategory(o)}
              options={categories}
              renderInput={(params) => <MDInput {...params} label="Category" />}
            />
            </Grid>
          <Grid size={6}>
          <Autocomplete
            value={contents.find((s) => s.id == action.actionUrl) || ({} as Content)}
            fullWidth
            getOptionLabel={(option: Content) => option.name}
            onChange={(e, o) => _setAction({ ...action, actionUrl: o?.id })}
            options={contents.filter((c) => c.category?.id == currentCategory?.id)}
              renderInput={(params) => <MDInput {...params} label="Content" />}
            />
          </Grid>
        </Grid>
      ) : (
        <Grid size={6}>
          <MDInput
            fullWidth
            label="Param"
            value={action?.actionUrl || ""}
            onChange={(e: any) => _setAction({ ...action, actionUrl: e.target.value })}
          />
        </Grid>
      )}
    </Grid>
  );
};
